import { __awaiter, __generator } from "tslib";
import { TuiFlowInTestMode } from '@office-start/teaching-ui-config-service';
import { CommercialTuiConfig, ConsumerTuiConfig } from './configuration';
import { getNewUserState } from './getNewUserState';
import { getValidator } from './getValidator';
var HomePageRoutes = new Set(['OfficeHome', 'Pwa']);
var checkNewUserRoute = function (config) {
    var _a;
    var currentRoute = (_a = config.context.router.getCurrentRoute()) === null || _a === void 0 ? void 0 : _a.route;
    var onHomePage = currentRoute
        ? HomePageRoutes.has(currentRoute)
        : false;
    return onHomePage;
};
var getStartingIndex = function (config, validItems, newUser, tuiNewUserState) {
    var _a;
    if (validItems.length === 0) {
        return -1;
    }
    if (newUser &&
        tuiNewUserState &&
        tuiNewUserState.Version === config.teachingUiConfig.version) {
        var stepsCompleted = (_a = tuiNewUserState === null || tuiNewUserState === void 0 ? void 0 : tuiNewUserState.StepsCompleted) !== null && _a !== void 0 ? _a : 0;
        if (stepsCompleted < validItems.length) {
            return stepsCompleted;
        }
    }
    return 0;
};
export var getValidSequences = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var identity, tuiSequenceConfig, tuiNewUserState, newUser, tuiSequence, validator, processedItems, validItems, i, _a, valid, item, standaloneItems, i, item, valid, startingIndex, shouldUpdateNewUserState;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                identity = config.identity;
                tuiSequenceConfig = identity.isMsa
                    ? ConsumerTuiConfig
                    : CommercialTuiConfig;
                return [4 /*yield*/, getNewUserState(config)];
            case 1:
                tuiNewUserState = _b.sent();
                newUser = tuiNewUserState
                    ? !tuiNewUserState.CompletedFirstRun
                    : // If there is an error assume they are not a new user
                        false;
                if (newUser && !checkNewUserRoute(config)) {
                    // If the user has not completed the first run
                    // but is on a page that is not the home page
                    // return [] so that we don't show anything
                    return [2 /*return*/, {
                            items: [],
                        }];
                }
                tuiSequence = newUser
                    ? tuiSequenceConfig.newUserTuiSequence
                    : tuiSequenceConfig.returningUserTuiSequence;
                validator = getValidator(config);
                return [4 /*yield*/, Promise.all(tuiSequence.map(function (item) {
                        return validator(item)
                            .then(function (valid) { return ({ valid: valid, item: item }); })
                            .catch(function () { return ({ valid: false, item: item }); });
                    }))];
            case 2:
                processedItems = _b.sent();
                validItems = [];
                for (i = 0; i < processedItems.length; i++) {
                    _a = processedItems[i], valid = _a.valid, item = _a.item;
                    if (valid) {
                        validItems.push(item);
                        if (item.stopProcessing) {
                            // no more sequences can be shown
                            break;
                        }
                    }
                }
                if (!(!validItems.length && tuiSequenceConfig.standaloneTuiItems.length)) return [3 /*break*/, 6];
                standaloneItems = tuiSequenceConfig.standaloneTuiItems;
                i = 0;
                _b.label = 3;
            case 3:
                if (!(i < standaloneItems.length)) return [3 /*break*/, 6];
                item = standaloneItems[i];
                return [4 /*yield*/, validator(item)];
            case 4:
                valid = _b.sent();
                if (valid) {
                    // Only one standalone callout can be shown at a time
                    validItems.push(item);
                    return [3 /*break*/, 6];
                }
                _b.label = 5;
            case 5:
                i++;
                return [3 /*break*/, 3];
            case 6:
                startingIndex = getStartingIndex(config, validItems, newUser, tuiNewUserState);
                shouldUpdateNewUserState = newUser &&
                    config.teachingUiConfig.tuiFlowInTestMode !==
                        TuiFlowInTestMode.NewUserReact;
                return [2 /*return*/, {
                        items: validItems,
                        impressionEvent: newUser
                            ? "Fre_New_Callouts_Impression" /* KnownImpressionInstrumentationEvents.FreNewCalloutsImpression */
                            : undefined,
                        shouldUpdateNewUserState: shouldUpdateNewUserState,
                        startingIndex: startingIndex,
                    }];
        }
    });
}); };
//# sourceMappingURL=getSequence.js.map